import { OrderData } from './order-data';
import { SubStateItem } from './sub-state-item';
import { LFProject } from './lfproject';
import { ResourceData } from './resource-data';
import { ResourceInfo } from './resource-info';

export class LiveForm {
  id = '';
  formData = '';
  nameAndRevision = '';
  order: OrderData = new OrderData();
  project: LFProject = new LFProject();
  subStates: SubStateItem[] = [];
  resourceData: ResourceData[] = [];
  attachedResources: ResourceInfo[] = [];
  idsOfHiddenItems: string[] = [];
}
